export default __webpack_public_path__ + "static/media/uploader-tandem-4.4331eec0.png";